import clsx from 'clsx'
import { useField, useFormikContext } from 'formik'
import React, { useEffect } from 'react'

import { InputContainer, InputStyled } from '@/components/Input/Input/Input.styles'
import useJobTemplates from '@/hooks/useJobs/useJobTemplates'

import { CreateJobFormValues } from './CreateJobForm'

interface Props {
  className?: string
  label?: string
  name: string
}

const DescriptionField = ({ className, label, name }: Props) => {
  const {
    values: { jobTemplate },
    setFieldValue,
  } = useFormikContext<CreateJobFormValues>()
  const [field, meta, { setError }] = useField({ name, type: 'text' })

  const isError = meta?.touched && !!meta?.error

  const jobTemplatesQuery = useJobTemplates()

  useEffect(() => {
    // derive value from selected jobTemplate
    if (!!jobTemplate) {
      const selectedJobTemplate = jobTemplatesQuery?.data?.jobTemplates?.find((jt) => jt?.id === jobTemplate)
      if (selectedJobTemplate) {
        setFieldValue('description', selectedJobTemplate?.description)
      }
    }
  }, [jobTemplate, jobTemplatesQuery?.data?.jobTemplates, setFieldValue])

  const handleChange = (e: React.ChangeEvent) => {
    field.onChange(e)
    setError(undefined)
  }

  return (
    <InputContainer className={className} isError={isError}>
      <label className="mb-2 font-medium leading-120 text-primary" htmlFor={'id'}>
        {label}
      </label>

      <textarea css={InputStyled} name={name} onChange={handleChange} rows={5} value={field.value} />

      <div className={clsx('flex w-full', isError ? 'justify-between' : 'justify-end')}>
        {isError && <p className="mt-1 font-medium text-label-xs text-tertiary">{meta?.error}</p>}
      </div>
    </InputContainer>
  )
}

export default DescriptionField
